import { PipeTransform } from '@angular/core';
var DniPipe = /** @class */ (function () {
    function DniPipe() {
    }
    DniPipe.prototype.transform = function (val) {
        return this.setDniFormat(val);
    };
    DniPipe.prototype.setDniFormat = function (value) {
        var text = this.parse(value && typeof value === 'number' && value.toFixed(0) || value || 0);
        var newVal = (parseInt(text || '0', 10) || 0).toString();
        return this.addThousandsSeparator(newVal, '.');
    };
    DniPipe.prototype.addThousandsSeparator = function (n, thousandsSeparatorSymbol) {
        return n.replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSeparatorSymbol);
    };
    DniPipe.prototype.parse = function (value) {
        var text = value && value.toString();
        return text && text.length && text !== '' ? text.toString().replace(/\D/g, '') : '';
    };
    return DniPipe;
}());
export { DniPipe };
